module.exports = __webpack_public_path__ + "h5/img/new_year6.e200f326.gif";